import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import HelpButton from 'help/HelpButton';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import PreferenceCheckbox from 'ui-library/inputs/PreferenceCheckbox';

import APIBearerTokenSection from './APIBearerTokenSection';

function APIKeysSection(): JSX.Element {
  return (
    <>
      <h3>Keys</h3>
      <table className="table table-striped api-key-table hidden">
        <thead>
          <tr>
            <th>Key</th>
            <th />
            <th />
            <th>Created At</th>
            <th />
          </tr>
        </thead>
        <tbody className="api-keys" />
      </table>
      <button type="button" className="button button--tertiaryGray button--medium js-generate-api-key">
        Generate New API Key
      </button>
    </>
  );
}

function APICredentialsSection(): JSX.Element {
  return (
    <>
      {window.bootstrap?.useBearerTokenAuthAPI && BenchlingConfig.ENABLE_BENCHLING_SUPPORT_BEARER_TOKEN_UI ? (
        <APIBearerTokenSection />
      ) : (
        <APIKeysSection />
      )}
    </>
  );
}

function ProfileAPISection(): JSX.Element {
  return (
    <>
      <h2>API</h2>
      <APICredentialsSection />
      <h3>Documentation</h3>
      <div>
        Get started with the API at{' '}
        <a
          title="docs.benchling.com"
          href="https://docs.benchling.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          docs.benchling.com
        </a>
        .
      </div>
      <div>
        Access the API reference with testing abilities on your{' '}
        <a
          title="tenant specific documentation page"
          href="/api/reference"
          target="_blank"
          rel="noopener noreferrer"
        >
          tenant specific documentation page
        </a>
        .
      </div>

      <h3>View IDs</h3>
      <div className="form-group">
        <div className="u-flex-display">
          <PreferenceCheckbox
            id="copyAPIIDs"
            label="Enable “Copy API ID” button"
            preferenceKey="ENABLE_COPY_API_ID"
          />
          <HelpButton
            renderContent={() => (
              <a
                title="Guide for using this feature"
                href="https://docs.benchling.com/docs/getting-started-1#copy-api-ids"
                target="_blank"
                rel="noopener noreferrer"
              >
                Guide for using this feature
              </a>
            )}
            iconClassName="u-tiny-spacing-left"
            placement={FloatingPlacement.TOP}
          />
        </div>
      </div>
    </>
  );
}

export default ProfileAPISection;
